module.exports = __webpack_public_path__ + "static/media/banner1-1.acb63d91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/utils/images/banner1-1.jpg
// module id = 857
// module chunks = 0